<template>
  <v-form ref="form">
    <v-row>
      <v-col class="pt-0 pb-0" cols="12">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formAccessories.store') }}</v-col>
        </v-row>
        <v-text-field :value="data.store" @input="value=>updateForm('store', value)" :label="$t('formAccessories.store')" solo="solo" flat="flat" outlined="outlined" required="required"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="12">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formAccessories.name') }}</v-col>
        </v-row>
        <v-text-field :value="data.name" @input="value=>updateForm('name', value)" :label="$t('formAccessories.name')" solo="solo" flat="flat" outlined="outlined" required="required"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="12">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formAccessories.amount') }}</v-col>
        </v-row>
        <v-text-field :value="data.amount" @input="value=>updateForm('amount', value)" :label="$t('formAccessories.amount')" solo="solo" flat="flat" outlined="outlined" required="required"></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: 'edit'
    }
  },
  methods: {
    updateForm (field, value) {
      this.$emit('update', { field, value })
    }
  }
}
</script>
